import React from 'react';
import '../../styles/index.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>Copyright © <span className="link">dbi360</span>. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
